













































import { defineComponent, ref, Ref } from '@nuxtjs/composition-api'
import IconFaSolidBars from '~icons/fa-solid/info-circle'

// Store
import { useCMSContentFragmentsStore } from '@/store/cms'

// Components
import Errors from '@/components/global/errors/Errors.vue'
import JsonRteField from '~/components/global/cms/JsonRteField.vue'

export default defineComponent({
  components: {
    IconFaSolidBars,
    JsonRteField,
    Errors,
  },
  setup() {
    const recombinantBodyContent = ref()
    const recombinantErrors: Ref<Record<string, string>[]> = ref([])
    const recombinanFragmentUID = 'bltf906955d0d290fbf'

    const setError = () => {
      recombinantErrors.value.push({
        message: `We are not able to fetch Recombinant modal information. Please reach out to our
                  <a class="anchorLink" href="/learn-and-support/support-information/technical-support">Support team</a>
                  for assistance.`,
      })
    }

    const loadModalContent = async () => {
      const cmsContentFragmentsStore = useCMSContentFragmentsStore()
      try {
        await cmsContentFragmentsStore.fetchContentFragment(recombinanFragmentUID)
        if (cmsContentFragmentsStore.cf[recombinanFragmentUID]) {
          recombinantBodyContent.value = cmsContentFragmentsStore.cf[recombinanFragmentUID]
        } else {
          setError()
        }
      } catch (error) {
        setError()
        console.error('Error fetching content fragment:', error)
      }
    }

    return {
      loadModalContent,
      recombinantBodyContent,
      recombinantErrors,
    }
  },
})
